import Section from '@components/Section/Section';
import ButtonBack from '~/components/ButtonBack/ButtonBack';
import { OrderDetails } from '~/components/OrderDetails';

const ConfirmDetailsPage = () => (
    <Section>
        <div className="container button-back-container">
            <ButtonBack />
        </div>
        <OrderDetails />
    </Section>
);

export default ConfirmDetailsPage;
